import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nextiva/next-ui';

import './PaymentDrawerHeader.scss';

export const blockName = 'payment-drawer-header';

const PaymentDrawerHeader = ({ shouldGoBack, backToPrev }) => (
  <div data-testid={blockName} className={`${blockName}`}>
    <Text kind="h2">
      {shouldGoBack && (
        <span className={`${blockName}__go-back`} onClick={backToPrev}>
          ←
        </span>
      )}
      Add New Payment
    </Text>
  </div>
);

PaymentDrawerHeader.propTypes = {
  shouldGoBack: PropTypes.bool.isRequired,
  backToPrev: PropTypes.func.isRequired,
};

export default PaymentDrawerHeader;
